/* eslint-disable react/jsx-no-target-blank */
import { optionalRender } from "app/common/ui/optionalRender"
import { option } from "fp-ts"
import { pipe } from "fp-ts/function"
import { FC } from "react"
import React from "react"
import { IconType } from "react-icons"
import { tw } from "twind"
import { css } from "twind/css"

type SocialName =
  | "Facebook"
  | "Instagram"
  | "LinkedIn"
  | "Pinterest"
  | "TikTok"
  | "Twitter"
  | "Vimeo"
  | "YouTube"

interface SocialLinkProps {
  Icon: IconType
  hexColor: string
  socialName: SocialName
  url: option.Option<string>
}

export const SocialLink: FC<SocialLinkProps> = ({ Icon, hexColor, socialName, url }) =>
  pipe(
    url,
    optionalRender((url) => (
      <li>
        <a
          className={tw(
            `text-gray-300`,
            css`
              &:hover {
                color: ${hexColor};
              }
              transition: all 100ms;
            `
          )}
          href={url}
          rel="noopener"
          target="_blank"
          title={socialName}
        >
          <Icon className={tw(`text-2xl`)} />
        </a>
      </li>
    ))
  )
